<template>
  <div style="padding: 10px">
    <div class="search-pc" style="margin: 10px 0">
      <el-input v-model="search.taskId" placeholder="请输入任务ID" style="width: 200px; margin-right: 10px"
                clearable @keyup.enter="load"></el-input>
      <el-input v-model="search.accountName" placeholder="请输入账号名" style="width: 200px; margin-right: 10px"
                clearable @keyup.enter="load"></el-input>
      <el-button type="primary" @click="load">查询</el-button>
      <el-button @click="resetData">重置</el-button>
    </div>

    <div class="search-mobile">
      <div class="search-inputs">
        <el-input v-model="search.taskId" placeholder="任务ID" size="small" clearable
                  @keyup.enter="load"></el-input>
        <el-input v-model="search.accountName" placeholder="账号名" size="small" clearable
                  @keyup.enter="load"></el-input>
      </div>
      <div class="action-btns">
        <el-button type="primary" size="small" @click="load">查询</el-button>
        <el-button size="small" @click="resetData">重置</el-button>
      </div>
    </div>

    <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%" class="table-pc">
      <el-table-column prop="taskId" label="任务ID" show-overflow-tooltip></el-table-column>
      <el-table-column prop="status" label="状态" :formatter="statusFormatter" show-overflow-tooltip></el-table-column>
      <el-table-column prop="accountName" label="账号名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="wxUnionId" label="UnionID" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="120">
        <template #default="scope">
          <el-button size="mini" type="warning" @click="downloadBin(scope.row)"
                     :loading="downloadLoading && currentDownloadRow === scope.row.taskId">下载Bin</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="table-mobile" v-loading="loading">
      <div class="card-item" v-for="item in tableData" :key="item.id">
        <div class="card-row">
          <span class="card-label">任务ID：</span>
          <span class="card-value">{{ item.taskId }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">状态：</span>
          <span class="card-value">{{ statusFormatter(item) }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">账号名：</span>
          <span class="card-value">{{ item.accountName }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">创建时间：</span>
          <span class="card-value">{{ item.createTime }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">UnionID：</span>
          <span class="card-value">{{ item.wxUnionId }}</span>
        </div>
        <div class="card-actions">
          <el-button size="mini" type="warning" @click="downloadBin(item)"
                     :loading="downloadLoading && currentDownloadRow === item.taskId">下载Bin</el-button>
        </div>
      </div>
    </div>

    <div class="pagination-wrapper">
      <el-pagination class="pagination-pc" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      <el-pagination class="pagination-mobile" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'WxQrCodeTask',
  data() {
    return {
      loading: false,
      downloadLoading: false,
      currentDownloadRow: null,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      search: { taskId: '', accountName: '' }
    }
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      let params = { current: this.currentPage, size: this.pageSize };
      if (this.search.taskId) {
        params.taskId = this.search.taskId;
      }
      if (this.search.accountName) {
        params.accountName = this.search.accountName;
      }
      request.get("/wx-qrcode/list", {
        params: params
      }).then(res => {
        this.loading = false;
        if (res.code === '0') {
          let data = res.data;
          if (data && data.records) {
            this.tableData = data.records;
            this.total = data.total || 0;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        } else {
          this.$message.error(res.msg || '加载失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error('网络错误');
        this.tableData = [];
        this.total = 0;
      });
    },
    downloadBin(row) {
      this.downloadLoading = true;
      this.currentDownloadRow = row.taskId;

      const token = localStorage.getItem('token') || sessionStorage.getItem('token');

      fetch(`/api/wx-qrcode/download-bin/${row.taskId}`, {
        method: 'GET',
        headers: {
          'token': token || '',
          'Accept': 'application/octet-stream'
        }
      })
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            let filename = (row.accountName || row.taskId) + '.bin';
            return response.blob().then(blob => ({ blob, filename }));
          })
          .then(({ blob, filename }) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100);
            this.$message.success('文件下载成功！');
          })
          .catch(error => {
            console.error('下载失败:', error);
            this.$message.error(error.message || '下载失败');
          })
          .finally(() => {
            this.downloadLoading = false;
            this.currentDownloadRow = null;
          });
    },
    resetData() {
      this.search = { taskId: '', accountName: '' };
      this.currentPage = 1;
      this.load();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    },
    statusFormatter(row) {
      const map = {
        0: '待扫码',
        1: '已扫码',
        2: '登录成功',
        3: '已过期',
        4: '已失败',
        5: '处理中',
        6: '角色已绑定'
      };
      return map[row.status] || '未知';
    }
  }
}
</script>

<style scoped>
.search-mobile, .table-mobile, .pagination-mobile { display: none; }
.search-mobile .search-inputs { display: flex; gap: 10px; margin-bottom: 10px; }
.search-mobile .action-btns { display: flex; gap: 10px; }
.card-item { background: #fff; border: 1px solid #ebeef5; border-radius: 4px; padding: 12px; margin-bottom: 10px; }
.card-row { display: flex; align-items: center; padding: 5px 0; font-size: 14px; }
.card-label { color: #909399; width: 80px; flex-shrink: 0; }
.card-value { color: #303133; flex: 1; }
.card-actions { display: flex; justify-content: flex-end; margin-top: 8px; padding-top: 8px; border-top: 1px solid #ebeef5; }

@media screen and (max-width: 768px) {
  .search-pc, .table-pc, .pagination-pc { display: none !important; }
  .search-mobile, .table-mobile, .pagination-mobile { display: block !important; }
  .card-item { background: #2a2a2a; border: 1px solid #3a3a3a; }
  .card-label { color: #909399; }
  .card-value { color: #e6a23c; }
}
</style>
